"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportDataExportSuccess = exports.reportDataExportReset = exports.reportDataExportError = exports.impactTypeExport = exports.fundTypeExportDownloadReset = exports.fundTypeExportDownload = exports.fundPrintBridgeExportReport = exports.fundPerformanceExport = exports.fundImpactExport = exports.fundExportDownload = exports.fundDonorExport = exports.fundDistributionList = void 0;
var _reportDataExport = require("./reportDataExport.constant");
// common success
var reportDataExportSuccess = function reportDataExportSuccess(actionType, data) {
  return {
    type: _reportDataExport.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.reportDataExportSuccess = reportDataExportSuccess;
var reportDataExportError = function reportDataExportError(actionType, error) {
  return {
    type: _reportDataExport.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * fund export download
 * @param payload
 * @returns api response
 * @description this function used to fund export download data.
 */
exports.reportDataExportError = reportDataExportError;
var fundExportDownload = function fundExportDownload(data) {
  return {
    type: _reportDataExport.actionTypes.FUND_EXPORT_DOWNLOAD,
    payload: data
  };
};

/**
 * fund type export download
 * @param payload
 * @returns api response
 * @description this function used to fund type export download data.
 */
exports.fundExportDownload = fundExportDownload;
var fundTypeExportDownload = function fundTypeExportDownload(data) {
  return {
    type: _reportDataExport.actionTypes.FUND_TYPE_EXPORT_DOWNLOAD,
    payload: data
  };
};

/**
 * fund type export download reset
 * @param payload
 * @returns api response
 * @description this function used to fund type export download reset data.
 */
exports.fundTypeExportDownload = fundTypeExportDownload;
var fundTypeExportDownloadReset = function fundTypeExportDownloadReset() {
  return {
    type: _reportDataExport.actionTypes.FUND_TYPE_EXPORT_DOWNLOAD_RESET
  };
};

/**
 * fund performance export
 * @param payload
 * @returns api response
 * @description this function used to export fund performance data.
 */
exports.fundTypeExportDownloadReset = fundTypeExportDownloadReset;
var fundPerformanceExport = function fundPerformanceExport(data) {
  return {
    type: _reportDataExport.actionTypes.FUND_PERFORMANCE_EXPORT,
    payload: data
  };
};

/**
 * fund donor export
 * @param payload
 * @returns api response
 * @description this function used to export fund donor data.
 */
exports.fundPerformanceExport = fundPerformanceExport;
var fundDonorExport = function fundDonorExport(data) {
  return {
    type: _reportDataExport.actionTypes.FUND_DONOR_EXPORT,
    payload: data
  };
};

/**
 * fund impact fun distribution list
 * @param payload
 * @returns api response
 * @description this function used to export fund distribution data.
 */
exports.fundDonorExport = fundDonorExport;
var fundDistributionList = function fundDistributionList(data) {
  return {
    type: _reportDataExport.actionTypes.FUND_DISTRIBUTION_LIST,
    payload: data
  };
};

/**
 * fund impact export
 * @param payload
 * @returns api response
 * @description this function used to export fund impact data.
 */
exports.fundDistributionList = fundDistributionList;
var fundImpactExport = function fundImpactExport(data) {
  return {
    type: _reportDataExport.actionTypes.FUND_IMPACT_EXPORT,
    payload: data
  };
};

/**
 * fund impact type export
 * @param payload
 * @returns api response
 * @description this function used to export fund impact type data.
 */
exports.fundImpactExport = fundImpactExport;
var impactTypeExport = function impactTypeExport(data) {
  return {
    type: _reportDataExport.actionTypes.IMPACT_TYPE_EXPORT,
    payload: data
  };
};

/**
 * fund print bridge Export
 * @param payload
 * @returns api response
 * @description this function used to export fund impact type data.
 */
exports.impactTypeExport = impactTypeExport;
var fundPrintBridgeExportReport = function fundPrintBridgeExportReport(data) {
  return {
    type: _reportDataExport.actionTypes.PRINT_BRIDGE_EXPORT,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset.
 */
exports.fundPrintBridgeExportReport = fundPrintBridgeExportReport;
var reportDataExportReset = function reportDataExportReset() {
  return {
    type: _reportDataExport.actionTypes.RESET
  };
};
exports.reportDataExportReset = reportDataExportReset;